export default __webpack_public_path__ + "static/default-og-9acc913f259839eb1e0953f847e0b787.jpg";